<app-card-etape [etape]="etape()" classes="h-full" showGroupes>
  <app-chip
    [label]="etape().groupes | getEtatEtape | convertEtatGroupeToString"
    [variant]="etape().groupes | getEtatEtapeVariant"
    ngProjectAs="etat"
  />
  <button [hlmDropdownMenuTrigger]="menuEtape" hlmBtn variant="ghost" size="icon">
    <ng-icon name="lucideEllipsisVertical" hlm />
  </button>
</app-card-etape>

<ng-template #menuEtape>
  <hlm-dropdown-menu>
    <hlm-dropdown-menu-group>
      <button (click)="voirGroupes()" hlmDropdownMenuItem>
        <ng-icon name="lucideEye" hlm />
        Voir les groupes
      </button>
      @if (!cartographie().estVerrouilleeOffreRegionale) {
        <button (click)="editerGroupes()" hlmDropdownMenuItem>
          <ng-icon name="lucidePen" hlm />
          Éditer les groupes
        </button>
        <button (click)="retirerEtape()" hlmDropdownMenuItem>
          <ng-icon name="lucideTrash" hlm />
          Retirer la formation du CFA
        </button>
      }
    </hlm-dropdown-menu-group>
  </hlm-dropdown-menu>
</ng-template>
